/* --- SHUBHAM CREATION BUY NOW LOGIC --- */
window.shubhamBuyNow = function(button) {
  const card = button.closest('.shubham-creation-product-card');
  const hiddenInput = card.querySelector('input[name="id"]');
  
  const hasSizes = card.querySelectorAll('.shubham-creation-size-badge').length > 0;
  let variantId = '';

  if (hasSizes) {
    if (!hiddenInput || !hiddenInput.value) {
       alert("Please select a size first!");
       return;
    }
    variantId = hiddenInput.value;
  } else {
    variantId = card.getAttribute('data-default-variant');
  }
  
  window.location.href = '/cart/add?id=' + variantId + '&return_to=/checkout';
};

/* --- SHUBHAM GRID SIZE SELECTION LOGIC --- */
window.shubhamSelectSize = function(badgeElement) {
  const card = badgeElement.closest('.shubham-creation-product-card');
  
  if (badgeElement.classList.contains('shubham-creation-size-soldout')) return;

  // Clear errors when a new size is selected
  const errorContainer = card.querySelector('.shubham-cart-error-message');
  if (errorContainer) {
    errorContainer.style.display = 'none';
    errorContainer.textContent = '';
  }

  card.querySelectorAll('.shubham-creation-size-badge').forEach(badge => {
    badge.classList.remove('selected'); 
  });
  
  badgeElement.classList.add('selected'); 
  
  const variantId = badgeElement.getAttribute('data-variant-id');
  const hiddenInput = card.querySelector('input[name="id"]');
  
  if (hiddenInput) {
    hiddenInput.value = variantId;
  }
};

/* --- AJAX NO-RELOAD ADD TO CART (WITH INVENTORY ERROR HANDLING) --- */
window.shubhamAddToCart = function(button) {
  const card = button.closest('.shubham-creation-product-card');
  const hiddenInput = card.querySelector('input[name="id"]');
  const errorContainer = card.querySelector('.shubham-cart-error-message');
  
  const hasSizes = card.querySelectorAll('.shubham-creation-size-badge').length > 0;
  let variantId = '';

  // Hide previous errors
  if (errorContainer) {
    errorContainer.style.display = 'none';
    errorContainer.textContent = '';
  }

  if (hasSizes) {
    if (!hiddenInput || !hiddenInput.value) {
      alert("Please select a size first!");
      return;
    }
    variantId = hiddenInput.value;
  } else {
    variantId = card.getAttribute('data-default-variant');
  }

  const originalText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;

  const formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(async (response) => {
    // If Shopify rejects it (usually a 422 error due to inventory), parse the error
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Not enough stock available.');
    }
    return response.json();
  })
  .then(() => {
    button.textContent = 'Added!';
    button.style.backgroundColor = '#4CAF50'; 
    button.style.color = '#fff';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      button.style.backgroundColor = ''; 
      button.style.color = '';
    }, 2000);

    fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newInner = temp.querySelector('.drawer__inner, #CartDrawer');
        const currentInner = drawer.querySelector('.drawer__inner, #CartDrawer');
        
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        } else {
          drawer.innerHTML = html; 
        }

        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active', 'is-active');
        }
      }
    });

    fetch('/?section_id=cart-icon-bubble')
    .then(res => res.text())
    .then(html => {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = html;
      }
    });

  })
  .catch(error => {
    // NEW: Catch the error and print it to the error container
    console.error('Add to cart failed:', error);
    
    if (errorContainer) {
      errorContainer.textContent = error.message;
      errorContainer.style.display = 'block';
    }

    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2500);
  });
};